// import console = require("console");


// 获取链接参数
export function getQueryVariable(param) {
  const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg) || window.location.hash.substring((window.location.hash.search(/\?/)) + 1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
}

// 判断字符是否为汉字，
export function isChinese(s){
	return /[\u4e00-\u9fa5]/.test(s);
}
// 把字符串中的汉字转换成Unicode
export function ch2Unicdoe(str){
	if(!str){
		return;
	}
	var unicode = '';
	for (var i = 0; i <  str.length; i++) {
		var temp = str.charAt(i);
		if(isChinese(temp)){
			unicode += '\\u' +  temp.charCodeAt(0).toString(16);
		}
		else{
			unicode += temp;
		}
	}
	return unicode;
}

// var str = 'love中国你好';
// console.info(ch2Unicdoe(str))    //  love\u4e2d\u56fd\u4f60\u597d
// js中Unicode编码 转汉字：
// 方法2， 遍历字符串
export function unicode2Ch(str){
	if(!str){
		return;
	}
	// 控制循环跃迁
	var len = 1;
	var result = '';
        // 注意，这里循环变量的变化是i=i+len 了
	for (var i = 0; i < str.length; i=i+len) {
		len = 1;
		var temp = str.charAt(i);
		if(temp == '\\'){
			// 找到形如 \u 的字符序列
			if(str.charAt(i+1) == 'u'){
				// 提取从i+2开始(包括)的 四个字符
				var unicode = str.substr((i+2),4); 
                                // 以16进制为基数解析unicode字符串，得到一个10进制的数字
				result += String.fromCharCode(parseInt(unicode,16).toString(10));
				// 提取这个unicode经过了5个字符， 去掉这5次循环
				len = 6;
			}
			else{
				result += temp;
			}
		}
		else{
			result += temp;
		}
	}
	return result;
}
 
// console.info("unicode2Ch:"+ unicode2Ch("love\u4e2d\u56fd1234\u4f60\u597d")) //love中国1234你好

export function hideMoreText(text, front, end = 0) {
  if (!text) {
    return '';
  }
  text = text.trim();
  if (text.length <= front + end) {
    return text
  } else {
    return text.substr(0, front) + "..." + text.substr(text.length - end);
  }
}